import React, { useEffect, useState } from 'react';
import { Box, Tab, Typography } from "@mui/material";
import { ROUTE_PATHS } from "src/routes/paths";
import Tabs from "@mui/material/Tabs";
import { useHistory, useLocation} from "react-router-dom";
import { ReportsTab } from './reports/ReportsTab';
import { useStoreContext } from 'src/store/context';
import { checkAdminRole } from 'src/store/common';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}
function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
      <div
          role="tabpanel"
          style={{padding:0, margin:0}}
          hidden={value !== index}
          id={`simple-tabpanel-${index}`}
          aria-labelledby={`simple-tab-${index}`}
          {...other}
      >
          {value === index && <Box>{children}</Box>}
      </div>
  );
};
function a11yProps(index: number) {
  return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
  };
}

export function StationDetail({ setTabValue }) {
  return (
    <Box>
      {/* Add your existing code here */}
      <Box mt={1}>
        <Typography
          variant="body2"
          color="primary"
          sx={{ cursor: "pointer", textDecoration: "underline" }}
          onClick={() => {
            setTabValue(0); // Switch to the "Stations" tab
          }}
        >
          View All Stations
        </Typography>
      </Box>
    </Box>
  );
};

const routes = [ROUTE_PATHS.pbiFireDanger, ROUTE_PATHS.pbiWeather,ROUTE_PATHS.pbiStationInformation,ROUTE_PATHS.pbiFieldSample, ROUTE_PATHS.pbiAdvanced];

export const Powerbi: React.FC = () =>{
    const history = useHistory();
    const location = useLocation();
    const [tabValue, setTabValue] = useState(0);
    const [state] = useStoreContext();
  
    useEffect(()=>{
      if(location?.pathname?.includes(ROUTE_PATHS.pbiFireDanger)){
        setTabValue(0)
      }
      else if(location?.pathname?.includes(ROUTE_PATHS.pbiWeather)){
        setTabValue(1)
      }
      else if(location?.pathname?.includes(ROUTE_PATHS.pbiStationInformation)){
        setTabValue(2)
      }
      else if(location?.pathname?.includes(ROUTE_PATHS.pbiFieldSample)){
        setTabValue(3)
      }
      else if(location?.pathname?.includes(ROUTE_PATHS.pbiAdvanced)){
        setTabValue(4)
      }
    },[location?.pathname])

  return (
    <div style={{padding: '.1%'}}>
      
      <Tabs 
        scrollButtons={false}
        value={tabValue}
        onChange={(event, newVal)=>{
          setTabValue(newVal); 
          history.push(`${routes[newVal]}`)
        }}
        className="subtabs"

      >
        <Tab label="Fire Danger" {...a11yProps(0)}/>
        <Tab label="Weather"{...a11yProps(1)}/>
        <Tab label="Station Information"{...a11yProps(2)}/>
        <Tab label="Field Sample"{...a11yProps(3)}/>
        {
          state.user && checkAdminRole(state.user) &&
          <Tab label="Advanced Analytics"{...a11yProps(4)}/>
        }
        
      </Tabs>

      <TabPanel value={tabValue} index={0}>
        <ReportsTab tab={0} name={'Fire Danger'} id={'nfdrs'}/>
      </TabPanel>
      <TabPanel value={tabValue} index={1}>
        <ReportsTab tab={1} name={'Weather'} id={'weather'}/>

      </TabPanel>
      <TabPanel value={tabValue} index={2}>
        <ReportsTab tab={2} name={'Station Information'} id={'station_information'}/>

      </TabPanel>
      <TabPanel value={tabValue} index={3}>
        <ReportsTab tab={3} name={'Field Sample'} id={'field_sample'}/>

      </TabPanel>
      {
          state.user && checkAdminRole(state.user) &&
          <TabPanel value={tabValue} index={4}>
            <ReportsTab tab={4} name={'Advanced Analytics'} id={'advanced_analytics'}/>
          </TabPanel>
      }
    </div>
  )
}